/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Following_To_AllInputs */

const en_following_to_all = /** @type {(inputs: Following_To_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Follow all changes of ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Follow all changes of {reference}" |
*
* @param {Following_To_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_to_all = /** @type {((inputs: Following_To_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_To_AllInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_to_all(inputs)
});